import { Component, Input, OnInit, EventEmitter, Output } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";
import { DataProvider } from "projects/packcert-web/src/app/providers/data.provider";
import { Message, SpinnerService, UtilsService } from "shared-components";
import { CultivosService } from "../../../../../../services/cultivos.service";

@Component({
  selector: "app-licencias-productor-cultivo",
  templateUrl: "./licencias-productor-cultivo.component.html",
})
export class LicenciasProductorCultivoComponent implements OnInit {
  private _licenciaProductorCultivoId;

  public licenciasProductorCultivo;
  public _licenciaProductorCultivo;

  public licenciasForm: UntypedFormGroup;

  public showError: boolean;
  public mensajes = new Array<Message>();
  public deleteModal = false;

  @Input() cultivoId: number;
  @Input() productorId: number;
  @Input() desProductor: string;

  @Output() refresh = new EventEmitter<boolean>();
  @Output() mensaje = new EventEmitter<string>();

  constructor(
    private _fb: UntypedFormBuilder,
    private readonly _spinnerService: SpinnerService,
    private readonly _cultivosService: CultivosService
  ) {}

  ngOnInit() {
    this.licenciasForm = this._fb.group({
      productor: [{ value: this.desProductor, disabled: true }],
      licencia: ["", Validators.required],
    });

    this.getLicenciasProductor();
  }

  public getLicenciasProductor() {
    this._spinnerService.showSpinner();
    this._cultivosService
      .getLicenciasByProductorCultivoId(this.cultivoId, this.productorId)
      .toPromise()
      .finally(() => {
        this._spinnerService.hideSpinner();
      })
      .then((resp) => {
        this.licenciasProductorCultivo = resp;
      });
  }

  public close() {
    this.refresh.emit(false);
  }

  public closeDeleteModal() {
    this.deleteModal = false;
    this.showError = false;
  }

  public add() {
    this.checkForm();
    if (this.licenciasForm.valid && !this.showError) {
      this._licenciaProductorCultivo = {
        cultivoId: this.cultivoId,
        productorId: this.productorId,
        nLicencia: this.licenciasForm.get("licencia").value,
      };
      this._spinnerService.showSpinner();
      this._cultivosService
        .createLicencia(this._licenciaProductorCultivo)
        .toPromise()
        .finally(() => {
          this._spinnerService.hideSpinner();
        })
        .then((resp) => {
          if (resp) {
            this.getLicenciasProductor();
            this.licenciasForm.get("licencia").reset();
          } else {
            this.showError = true;
            this.mensajes.push({
              class: "error",
              message: "global.error.noResponse",
            });
          }
        });
    }
  }

  public delete() {
    this._spinnerService.showSpinner();
    this._cultivosService
      .deleteLicencia(this._licenciaProductorCultivoId)
      .toPromise()
      .finally(() => {
        this._spinnerService.hideSpinner();
      })
      .then(() => {
        this.closeDeleteModal();
        this.pushMessage("global.success.itemDeleted");
        this.getLicenciasProductor();
      });
  }

  public askDelete(licencia) {
    this._licenciaProductorCultivoId = licencia.id;
    this.deleteModal = true;
  }

  private checkForm() {
    this.showError = this.licenciasForm.invalid;
    if (this.showError) {
      this.mensajes.push({ class: "error", message: "global.error.required" });
    }
  }

  public pushMessage(mensaje) {
    this.showError = true;
    this.mensajes.push({ class: "success", message: mensaje });
  }
}
